var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordle"},[(!_vm.wordleStore?.game)?[_c('p',[_vm._v("Finding opponent...")])]:[_c('wordle-intro',{on:{"ended":_vm.introEnded}}),_vm._v(" "),_c('wordle-game'),_vm._v(" "),(_vm.wordleStore.gameOver)?_c('wordle-result'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }